export default "__VITE_ASSET__DguEptjp__"